import React from 'react'

import PanduanPerilakuKerjaApp from 'app/KinerjaPage/pages/Panduan/PerilakuKerja'
import KinerjaLayout from 'app/KinerjaPage/components/KinerjaLayout'
import PageHeader from 'app/KinerjaPage/components/PageHeader'
import { isToggleEnabled } from 'configs/toggle-feature'

export async function getServerSideProps() {
  const isKinerjaEnabled = await isToggleEnabled('kinerja-enabled')

  if (!isKinerjaEnabled) {
    return {
      redirect: {
        destination: '/404',
        permanent: false,
      },
    }
  }

  return { props: {} }
}

const PanduanPerilakuKerja = () => {
  return <PanduanPerilakuKerjaApp />
}

PanduanPerilakuKerja.Layout = KinerjaLayout

PanduanPerilakuKerja.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
  header: PageHeader,
}

export default PanduanPerilakuKerja
